<div class="ui-g-12 ui-md-12">
    <div *ngIf="!mostrar">
        <i class="pi pi-spin pi-spinner" style="font-size: 5em"></i>

    </div>
    <div *ngIf="mostrar">

        <div class="">
            <app-simple-table 
                [cols]="cols" 
                [listarTodos]="listarTodos" 
                [items]="control" 
                [database]="database"
                [showInfo]="showInfo" 
                [mostrarInformes]="mostrarInformes" 
                [showDuplicate]="showDuplicate"
                (listarCamposEmmit)="listarCampos()" 
                (changeValueRevisionEmmit)="changeValueRevision($event)"
                (changeValueEmmit)="changeValue($event)" 
                (iniciarEmmit)="iniciar()" (deleteEmmit)="delete($event)"
                (consultarInformes)="consultar($event)" 
                (duplicateEmmit)="duplicate($event)"></app-simple-table>
            <br>

        </div>

    </div>
</div>
<p-confirmDialog header="Confirmación" icon="pi pi-exclamation-triangle"></p-confirmDialog>


<p-toast [style]="{marginTop: '80px'}"></p-toast>